import {API_URL} from '../../../request'

export const addWebsiteLeadUrl = () => {
    return API_URL + `/websiteLead/add`
}
export const listWebsiteLeadUrl = () => {
    return API_URL + `/websiteLead/list`
}
export const updateWebsiteLeadUrl = () => {
    return API_URL + `/websiteLead/update`
}
